import { combineReducers } from '@reduxjs/toolkit'
import { estimatorReducer, appLoaderReducer, appNotificationsReducer, appApisReducer } from './slices'

const rootReducer = combineReducers({
  estimator: estimatorReducer,
  appLoader: appLoaderReducer,
  appNotifications: appNotificationsReducer,
  appApis: appApisReducer,
})

export default rootReducer;
